<div class="container-fluid">
    <div class="row">
        <router-outlet></router-outlet>
    </div>
</div>
